import React from "react";
import aboutcontent from "../../images/about/about-content.svg";

const AboutContent = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between align-items-center">
          <div className="col-lg-6">
            <div className="px-4">
              <img src={aboutcontent} alt="About" />
            </div>
          </div>
          <div className="col-lg-6 d-lg-flex flex-lg-column gap-3">
            <h2 className="heading_text text-dark text-start mb-0">About Us</h2>
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin UK is a revolutionary rewards and loyalty platform based
              in the United Kingdom. Our mission is to help businesses grow
              through smart, innovative advertising, while giving customers real,
              increasing value every time they shop.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              We’ve created a unique non-investment digital reward system where
              customers earn free TopCoin UK with every purchase from
              participating shops, restaurants, and companies. These TopCoin go
              into their personal Customer Wallets and unlock cash rewards
              through a structured, transparent system. The more TopCoin you
              collect, the more you earn.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              Unlike traditional points or loyalty schemes, TopCoin UK 
              only go up in value—they never expire, and they never lose worth.
              Every customer and business is connected to a secure,
              blockchain-based network where rewards and wallets grow together.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutContent;
